import { useEffect, useState } from 'react';
import { SerialService, serialsByItem } from '../../services/serial.service';
import { AuthService } from '../../services/auth.service';
import { usePermission } from '../../hooks/usePermission';
import { PERMISSIONS } from '../../constants/permissions';

/**
 * F6b polish: the serials a posted document moved, grouped by item id, so each line of a posted challan or a completed
 * transfer can list them. Loads only when `enabled` and the caller holds STOCK_VIEW; a failure just shows no serials
 * (the document itself still renders).
 */
export const useDocumentSerials = (sourceId: string | undefined, movement: 'SALE_DELIVERY' | 'TRANSFER_OUT',
  enabled: boolean): Record<string, string[]> => {
  const canView = usePermission(PERMISSIONS.STOCK_VIEW);
  const [byItem, setByItem] = useState<Record<string, string[]>>({});
  useEffect(() => {
    const institutionId = AuthService.getSelectedInstitution();
    if (!enabled || !canView || !sourceId || !institutionId) { setByItem({}); return undefined; }
    let alive = true;
    SerialService.byDocument(institutionId, sourceId, movement)
      .then((rows) => { if (alive) setByItem(serialsByItem(rows)); })
      .catch(() => { if (alive) setByItem({}); });
    return () => { alive = false; };
  }, [sourceId, movement, enabled, canView]);
  return byItem;
};
